import React, { useEffect, useState } from "react";
import ClassCard from "../components/ClassCard";
import { api } from "../lib/api";

export default function Classes() {
  const [classes, setClasses] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/classes").then((r) => setClasses(r.data)).catch(() => {});
  }, []);

  const categories = ["All", ...Array.from(new Set(classes.map((c) => c.category)))];
  const filtered = filter === "All" ? classes : classes.filter((c) => c.category === filter);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="classes-page">
      <span className="label-overline">// The Library</span>
      <h1 className="font-display text-5xl sm:text-6xl tracking-widest leading-none mt-3 mb-12">All Classes</h1>

      <div className="flex flex-wrap gap-2 mb-10" data-testid="category-filter">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setFilter(cat)}
            data-testid={`filter-${cat}`}
            className={`label-overline px-4 py-2 border transition-colors ${
              filter === cat ? "border-[#D4A574] text-[#D4A574]" : "border-white/15 text-zinc-400 hover:border-white/40 hover:text-white"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="border border-dashed border-white/10 p-16 text-center text-zinc-500" data-testid="empty-classes">
          <p className="label-overline">No classes found</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="classes-grid">
          {filtered.map((c) => <ClassCard key={c.id} cls={c} />)}
        </div>
      )}
    </div>
  );
}
